import { useCallback } from 'react';
import { getSelectorBasedStoreValue } from 'v2/modules/withRunForm/redux/selector';
import { useSelector } from 'react-redux';
import { findIntentReference, findPipeReference, findCaseReference } from 'v3/quantConfig/reference/index';

const useReference = () => {
  const quantConfig = useSelector((state) => getSelectorBasedStoreValue(state, 'quantConfig'));
  const { cases, pipeConfigs } = quantConfig;

  const getAllIntentReference = useCallback((caseIdx, intentIdx) => {
      return findIntentReference(caseIdx, intentIdx, quantConfig)
  }, [cases, pipeConfigs]);

  const getAllCaseReference = useCallback((caseIdx) => {
    if (!quantConfig.cases[caseIdx]) return [];
    return findCaseReference(caseIdx, quantConfig);
  }, [cases, pipeConfigs]);

  const getAllPipeReference = useCallback((pipeIdx) => {
    const { name = '', type = '' } = quantConfig.pipeConfigs[pipeIdx] ?? {};
    if (!name || !type) return [];
    return findPipeReference(pipeIdx, quantConfig)
  }, [cases, pipeConfigs]);


  return {
    getAllIntentReference,
    getAllCaseReference,
    getAllPipeReference
  };
};

export default useReference;